export default __webpack_public_path__ + "static/media/cirrus.b3579248.svg";